import React from 'react';
import { ModeRestrictions } from '../../hooks/useModeRestrictions';
import CustomSelect from '../ui/CustomSelect';

interface WrinkleRemovalSettingsProps {
  mode: string;
  setMode: React.Dispatch<React.SetStateAction<string>>;
  modeRestrictions: ModeRestrictions;
}

const WrinkleRemovalSettings: React.FC<WrinkleRemovalSettingsProps> = ({
  mode,
  setMode,
  modeRestrictions,
}) => {
  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-text-heading mb-1">
          Mode
          {!modeRestrictions.hasInitialLoad && (
            <span className="ml-2 text-xs text-text-description">(Loading...)</span>
          )}
        </label>
        <div className="relative">
          <CustomSelect
            value={mode}
            onChange={(value) => setMode(value)}
            options={modeRestrictions.availableModes.map((modeOption) => {
              let planRequirement = '';
              if (modeOption.disabled && modeOption.requiresPlan) {
                const minPlan = modeOption.requiresPlan[0];
                switch (minPlan) {
                  case 'plus':
                    planRequirement = ' (Plus Plan Required)';
                    break;
                  case 'pro':
                    planRequirement = ' (Pro Plan Required)';
                    break;
                  case 'enterprise':
                    planRequirement = ' (Enterprise Plan Required)';
                    break;
                  default:
                    planRequirement = ' (Upgrade Required)';
                }
              }
              return {
                value: modeOption.value,
                label: `${modeOption.label}${planRequirement}`,
                disabled: modeOption.disabled
              };
            })}
            disabled={!modeRestrictions.hasInitialLoad}
            className="w-full"
          />
          {modeRestrictions.error && (
            <p className="text-xs text-red-600 mt-1">{modeRestrictions.error}</p>
          )}
          {!modeRestrictions.canUseMode(mode) && modeRestrictions.hasInitialLoad && (
            <p className="text-xs text-orange-600 mt-1">
              <i className="fas fa-exclamation-triangle mr-1"></i>
              {modeRestrictions.getRestrictedModeMessage(mode)}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default WrinkleRemovalSettings;
